import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBo5r-ZqWMtigGAxMEIPjj4uqBW-UDSaJk",
  authDomain: "myworkin-platform.firebaseapp.com",
  projectId: "myworkin-platform",
  storageBucket: "myworkin-platform.firebasestorage.app",
  messagingSenderId: "486022139389",
  appId: "1:486022139389:web:b7faa86bc2e452d6369d94"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app; 